import React, {
  Fragment,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { Image, LI, Spinner, UL } from "../../../../AbstractElements";
import ChatAppContext from "../../../../_helper/Chat";
import start_conversion_1 from "../../../../assets/images/start-conversion_1.jpg";
import ChatMessageItem from "./ChatMessageItem";
import axios from "../../../../axios/axios";
import { useSelector } from "react-redux";
import AutoSizer from "react-virtualized-auto-sizer"; // Import AutoSizer
import { FixedSizeList as List } from "react-window";
import { setChatLoading, setChatMessages } from "../../../../utils/chatSlice";
import { useDispatch } from "react-redux";
import moment from "moment";

const ChatMessageList = () => {
  // const {
  //   allMemberss,
  //   chatss,
  //   // selectedUserr,
  //   currentUserr,
  //   fetchChatMemberAsyn,
  //   fetchChatAsyn,
  // } = useContext(ChatAppContext);
  const baseurl = useSelector((store) => store.baseUrl);
  const selectedUserr = useSelector((state) => state?.users?.selectedUser);
  const [userdetails, setUserdetails] = useState(
    JSON.parse(localStorage.getItem("userdetails"))
  );
  const dispatch = useDispatch();
  const scrollRef = useRef(null);
  // const [chatHistory, setChatHistory] = useState([]);
  // const [visibleMessages, setVisibleMessages] = useState([]); // Messages displayed
  // const [hasMoreMessages, setHasMoreMessages] = useState(false); // Check if older messages are available
  // const [loading, setLoading] = useState(true); // To show a loading indicator
  // const chatContainerRef = useRef(null); // Reference to the chat container
  // Access the chat messages and loading state from the Redux store
  const chatMessages = useSelector((state) => state?.chats?.chatmessages);
  const chatLoading = useSelector((state) => state?.chats?.chatloading);
  const isgroup = useSelector((state) => state?.users?.isGroup);

  // const PAGE_SIZE = 20; // Number of messages to load at a time
  // console.log(chatHistory, "chatHistory...");

  // Ref to store the latest chatMessages
  const chatMessagesRef = useRef(chatMessages);

  // Keep the ref updated with the latest chatMessages
  useEffect(() => {
    chatMessagesRef.current = chatMessages;
  }, [chatMessages]);

  useEffect(() => {
    // fetchChatHistory(selectedUserr, userdetails);
    // if (selectedUserr) {
    //   fetchChatHistory(selectedUserr, userdetails);
    // }

    // Set up polling every 5 seconds
    const pollingInterval = setInterval(() => {
      // fetchChatHistoryAPIPoll(selectedUserr, userdetails);
      if (selectedUserr) {
        // Ensure selectedUserr is available
        fetchChatHistoryAPIPoll(selectedUserr, userdetails);
      }
    }, 8000);

    // Clean up on unmount or when selectedUserr changes
    return () => clearInterval(pollingInterval);
  }, [selectedUserr]);

  useEffect(() => {
    if (selectedUserr) {
      fetchChatHistory(selectedUserr, userdetails);
    }
  },[selectedUserr])

  // Centralized Fetch Function
  const fetchChatHistory = async (selectedUserr, userdetails) => {
    if (!selectedUserr) return; // Exit if no user is selected

    // Only show loading indicator for the first fetch, not for polling
    // const isInitialLoad = chatMessages.length === 0;

    // if (isInitialLoad) {
    //   dispatch(setChatLoading({ isLoading: true }));
    // }
    dispatch(setChatLoading({ isLoading: true }));
    dispatch(setChatMessages([]));

    try {
      let apiEndpoint = "";
      const formData = new FormData();

      // Append common fields
      formData.append("AUTHORIZEKEY", process.env.REACT_APP_AUTHORIZE_KEY);
      formData.append("PHPTOKEN", localStorage.getItem("id_token"));

      // Determine API endpoint and specific fields
      if (isgroup) {
        apiEndpoint = `${baseurl}/common_api/openhistorygroupchat/`;
        formData.append("groupid", selectedUserr?.group_id);
        formData.append("memberid", selectedUserr?.member_id);
      } else {
        apiEndpoint = `${baseurl}/common_api/openhistorychat/`;
        formData.append("receiver_id", selectedUserr.employee_id);
        formData.append("receiver_type", selectedUserr.user_type);
        const { employee_id: senderId, user_type: senderType } = userdetails;
        formData.append("sender_id", senderId);
        formData.append("sender_type", senderType);
      }

      // Fetch data from the API
      const response = await fetch(apiEndpoint, {
        method: "POST",
        body: formData,
      });

      const result = await response.json();
      const { STATUS, DATA } = result[0] || {};

      if (STATUS == "SUCCESS" && DATA.length > 0) {
        // Compare current messages with the existing messages in Redux state
        // const isDataChanged =
        //   JSON.stringify(chatMessages) != JSON.stringify(DATA);
        // console.log(
        //   JSON.stringify(chatMessages) != JSON.stringify(DATA),
        //   "json ccompare"
        // );

        // if (isDataChanged) {
        dispatch(setChatMessages(DATA)); // Only update if data is different
        // }
      } else {
        // console.error("Failed to fetch chat history:", STATUS);
      }
    } catch (error) {
      console.error("Error fetching chat history:", error.message);
    } finally {
      dispatch(setChatLoading({ isLoading: false }));
    }
  };

  // for api polling
  const fetchChatHistoryAPIPoll = async (selectedUserr, userdetails) => {
    if (!selectedUserr) return; // Exit if no user is selected

    // Only show loading indicator for the first fetch, not for polling
    // const isInitialLoad = chatMessages.length == 0;

    // if (isInitialLoad) {
    //   dispatch(setChatLoading({ isLoading: true }));
    // }
    // dispatch(setChatLoading({ isLoading: true }));
    // dispatch(setChatMessages([]));

    try {
      let apiEndpoint = "";
      const formData = new FormData();

      // Append common fields
      formData.append("AUTHORIZEKEY", process.env.REACT_APP_AUTHORIZE_KEY);
      formData.append("PHPTOKEN", localStorage.getItem("id_token"));

      // Determine API endpoint and specific fields
      if (isgroup) {
        apiEndpoint = `${baseurl}/common_api/openhistorygroupchat/`;
        formData.append("groupid", selectedUserr?.group_id);
        formData.append("memberid", selectedUserr?.member_id);
      } else {
        apiEndpoint = `${baseurl}/common_api/openhistorychat/`;
        formData.append("receiver_id", selectedUserr.employee_id);
        formData.append("receiver_type", selectedUserr.user_type);
        const { employee_id: senderId, user_type: senderType } = userdetails;
        formData.append("sender_id", senderId);
        formData.append("sender_type", senderType);
      }

      // Fetch data from the API
      const response = await fetch(apiEndpoint, {
        method: "POST",
        body: formData,
      });

      const result = await response.json();
      const { STATUS, DATA } = result[0] || {};

      if (STATUS == "SUCCESS" && DATA.length > 0) {
        // Compare current messages with the existing messages in Redux state
        // console.log(chatMessages?.length, "chatMessages?.length...");
        // console.log(DATA?.length, "DATA?.length...");
        // const isDataChanged =
        //   JSON.stringify(chatMessages) != JSON.stringify(DATA);
        // const isDataChanged = chatMessages?.length != DATA?.length;
        // console.log(chatMessages?.length != DATA?.length, "json ccompare");
        // Compare with the latest chatMessages from ref
        // console.log(chatMessagesRef.current, "chatMessagesRef.current..");
        // console.log(
        //   chatMessagesRef.current.length,
        //   "chatMessagesRef.current.length.."
        // );
        // console.log(DATA?.length, "DATA?.length...");
        const isDataChanged = chatMessagesRef.current.length != DATA?.length;
        if (isDataChanged) {
          dispatch(setChatMessages(DATA)); // Only update if data is different
        }
        // else {
        //   dispatch(setChatMessages(DATA)); // Only update if data is different
        // }
      } else {
        // console.error("Failed to fetch chat history:", STATUS);
        // dispatch(setChatMessages([])); // Only update if data is different
      }
    } catch (error) {
      console.error("Error fetching chat history:", error.message);
    } finally {
      // if (isInitialLoad) {
      //   dispatch(setChatLoading({ isLoading: false }));
      // }
    }
  };

  // Scroll to bottom on chatMessages update
  const scrollToBottom = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  };

  useEffect(() => {
    scrollToBottom();
  }, [chatMessages]);

  // const Row = ({ index }) => {
  //   const message = chatHistory[index];
  //   return (
  //     <div>
  //       <ChatMessageItem key={message?.order_no || index} item={message} />
  //     </div>
  //   );
  // };

  // Load more messages when scrolling up
  // const loadMoreMessages = (history, initial = false) => {
  //   // alert(loading || !hasMoreMessages)
  //   // if (loading || !hasMoreMessages) return;
  //   // setLoading(true);

  //   const currentLength = visibleMessages.length;
  //   const nextMessages = history.slice(
  //     Math.max(0, history.length - currentLength - PAGE_SIZE),
  //     history.length - currentLength
  //   );

  //   setVisibleMessages((prev) => [...prev, ...nextMessages]);

  //   setHasMoreMessages(history.length > currentLength + PAGE_SIZE);
  //   // // setLoading(false);

  //   // Scroll to the bottom on initial load
  //   if (initial && chatContainerRef.current) {
  //     chatContainerRef.current.scrollTop =
  //       chatContainerRef.current.scrollHeight;
  //   }
  // };

  // // Handle scrolling up for lazy loading
  // const handleScroll = () => {
  //   if (chatContainerRef.current.scrollTop == 0) {
  //     loadMoreMessages(chatHistory);
  //   }
  // };

  const groupMessagesByDate = (messages) => {
    return messages.reduce((acc, message) => {
      const messageDate = moment(message.created_dt, "DD/MM/YYYY hh:mm a");
      const today = moment();
      const yesterday = moment().subtract(1, "days");

      let formattedDate;
      if (messageDate.isSame(today, "day")) {
        formattedDate = "Today";
      } else if (messageDate.isSame(yesterday, "day")) {
        formattedDate = "Yesterday";
      } else {
        formattedDate = messageDate.format("D MMMM YYYY"); // Example: 5 February 2025
      }

      if (!acc[formattedDate]) {
        acc[formattedDate] = [];
      }
      acc[formattedDate].push(message);

      return acc;
    }, {});
  };

  return (
    <Fragment>
      {selectedUserr ? (
        <div
          className="chat-history chat-msg-box custom-scrollbar"
          ref={scrollRef}
        >
          <UL attrUL={{ className: "simple-list" }}>
            {chatLoading ? (
              <div className="loader-box chat-loader">
                <Spinner attrSpinner={{ className: "loader-9" }} />
              </div>
            ) : selectedUserr && chatMessages?.length > 0 ? (
              Object.entries(groupMessagesByDate(chatMessages)).map(
                ([dateLabel, messages]) => (
                  <Fragment key={dateLabel}>
                    {/* 🟢 Date Header */}
                    <LI
                      attrLI={{
                        className:
                          "clearfix border-0 text-center fw-bolder mb-2 chat-date-header",
                      }}
                    >
                      <span className="chat-date-text">{dateLabel}</span>
                    </LI>

                    {/* 🟢 Render Messages */}
                    {messages.map((item, index) => (
                      <ChatMessageItem key={index} item={item} />
                    ))}
                  </Fragment>
                )
              )
            ) : (
              <div>
                <Image
                  attrImage={{
                    className: "img-fluid start-conversion-img",
                    src: `${baseurl}/public/images/supportportal/start-conversion_1.jpg`,
                    alt: "start_conversion_1",
                  }}
                />
              </div>
            )}
          </UL>
        </div>
      ) : (
        <div className="loading"></div>
      )}

      {/* <UL attrUL={{ className: "simple-list" }}>
{chatLoading ? (
  <div className="loader-box chat-loader">
    <Spinner attrSpinner={{ className: "loader-9" }} />
  </div>
) : selectedUserr && chatMessages?.length > 0 ? (
  chatMessages?.map((item, index) => {
    return (
      <ChatMessageItem
        key={index}
        item={item}
        // currentUserId={userdetails?.employee_id}
      />
    );
  })
) : (
  <div>
    <Image
      attrImage={{
        className: "img-fluid",
        src: `${baseurl}/public/images/supportportal/start-conversion_1.jpg`,
        alt: "start_conversion_1",
      }}
    />
  </div>
)}
</UL> */}
    </Fragment>
  );
};
export default ChatMessageList;
